import React, { useState } from 'react';
import { navigatePreviewWindow, openPendingPreviewWindow, requestPreviewAccess } from '../utils/previewAccess';

interface GenerationPreviewButtonProps {
  generationId: string;
  /** Отладочное превью (учитывается сервером только для администратора). */
  debug?: boolean;
}

const GenerationPreviewButton: React.FC<GenerationPreviewButtonProps> = ({ generationId, debug = false }) => {
  const [opening, setOpening] = useState(false);
  const [error, setError] = useState('');

  const openPreview = async () => {
    if (opening) return;
    setError('');
    // Новая вкладка открывается непосредственно по клику, до запроса доступа.
    const previewWindow = openPendingPreviewWindow();
    if (!previewWindow) {
      setError('Разрешите открытие новой вкладки для просмотра сайта.');
      return;
    }
    setOpening(true);
    try {
      // Адрес превью (в т.ч. на отдельном origin) берётся из ответа сервера.
      const previewUrl = await requestPreviewAccess(generationId, { debug });
      navigatePreviewWindow(previewWindow, previewUrl);
    } catch {
      previewWindow.close();
      setError('Не удалось открыть сайт. Попробуйте ещё раз.');
    } finally {
      setOpening(false);
    }
  };

  return (
    <div style={{ display: 'inline-flex', flexDirection: 'column', alignItems: 'flex-start', gap: 6 }}>
      <button
        type="button"
        className="u2-btn is-success"
        title="Открыть сайт в новой вкладке без скачивания"
        disabled={opening}
        aria-busy={opening}
        onClick={openPreview}
      >
        {opening ? 'Открываем…' : 'Посмотреть сайт'}
      </button>
      {error && <span role="alert" style={{ maxWidth: 260, fontSize: 12, textAlign: 'left', whiteSpace: 'normal' }}>{error}</span>}
    </div>
  );
};

export default GenerationPreviewButton;
